import { opcoesContribuicao } from './contribuicao';
import { opcoesRenda } from './renda';
import { opcoesCrescimentoSalario } from './crescimentoSalario';
import {
  opcoesRetornoRealInvestimento,
  opcoesRetornoRealInvestimentoTaesa,
} from './retornoRealInvestimento';
import { opcoesQtdEstimadaRemuneracao } from './qtdEstimadaRemuneracao';
import { opcoesPercentualSaque } from './percentualSaque';
import { opcoesPercentualSaldo } from './percentualSaldo';
import { opcoesPrazoRendaTemporaria } from './prazoRendaTemporaria';
import { opcoesRendaConversao } from './rendaConversao';

const ID_PERCENT_SALDO = '1';
const ID_TEMPORARIO = '2';
const ID_VITALICIO = '3';
const ID_CONJUGADO = '4';

export {
  opcoesContribuicao,
  opcoesRenda,
  opcoesRendaConversao,
  opcoesCrescimentoSalario,
  opcoesRetornoRealInvestimento,
  opcoesRetornoRealInvestimentoTaesa,
  opcoesQtdEstimadaRemuneracao,
  opcoesPercentualSaque,
  opcoesPercentualSaldo,
  opcoesPrazoRendaTemporaria,
  ID_PERCENT_SALDO,
  ID_TEMPORARIO,
  ID_VITALICIO,
  ID_CONJUGADO,
};
